export default "__VITE_ASSET__Cg9xFCKg__"